/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputEwSuppressionSession } from './OutputEwSuppressionSession';
import {
    OutputEwSuppressionSessionFromJSON,
    OutputEwSuppressionSessionFromJSONTyped,
    OutputEwSuppressionSessionToJSON,
} from './OutputEwSuppressionSession';

/**
 * 
 * @export
 * @interface OutputEwSuppressionSessionsList
 */
export interface OutputEwSuppressionSessionsList {
    /**
     * 
     * @type {Array<OutputEwSuppressionSession>}
     * @memberof OutputEwSuppressionSessionsList
     */
    sessions?: Array<OutputEwSuppressionSession>;
}

/**
 * Check if a given object implements the OutputEwSuppressionSessionsList interface.
 */
export function instanceOfOutputEwSuppressionSessionsList(value: object): boolean {
    return true;
}

export function OutputEwSuppressionSessionsListFromJSON(json: any): OutputEwSuppressionSessionsList {
    return OutputEwSuppressionSessionsListFromJSONTyped(json, false);
}

export function OutputEwSuppressionSessionsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputEwSuppressionSessionsList {
    if (json == null) {
        return json;
    }
    return {
        
        'sessions': json['sessions'] == null ? undefined : ((json['sessions'] as Array<any>).map(OutputEwSuppressionSessionFromJSON)),
    };
}

export function OutputEwSuppressionSessionsListToJSON(value?: OutputEwSuppressionSessionsList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sessions': value['sessions'] == null ? undefined : ((value['sessions'] as Array<any>).map(OutputEwSuppressionSessionToJSON)),
    };
}

